import { RankingPresentation } from './RankingPresentation';
import { useRankingPresentation } from './hooks/use-ranking-presentation';

export function RankingPresentationDataHandler() {
  const presentationProps = useRankingPresentation();

  return <RankingPresentation {...presentationProps} />;
}
